import { Trans } from '@lingui/macro';
import { motion } from 'motion/react';
import { useContext } from 'react';

import classes from './P2PAdminPanel.module.css';
import { P2PContext } from './P2PContext';
import { IWaitingListItem } from '@/types/key-exchange';

interface IProps {
    user: IWaitingListItem;
    selected: boolean;
    toggleSelect: (deviceId: string) => void;
}
const P2PWaitingUsersListItem: React.FC<IProps> = ({
    user,
    selected,
    toggleSelect,
}) => {
    const context = useContext(P2PContext);
    const { activeUserItem, setActiveUserItem } = context;

    const chooseUser = () => {
        setActiveUserItem(user);
    };

    return (
        <motion.div
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ delay: 0.01 }}
            style={{ cursor: 'pointer', borderRadius: 12, paddingInline: 6 }}
            className={`${classes['flex']} ${
                activeUserItem && activeUserItem.user_id === user?.user_id
                    ? classes['active-user']
                    : ''
            }`}>
            <input
                name="select-waiting-item"
                type="checkbox"
                checked={selected}
                onChange={() => toggleSelect(user.device_id)}
            />
            <div onClick={chooseUser} className={`${classes['waiting-item']}`}>
                <h5 className={classes['name']}>{user?.name}</h5>
                <p>
                    <Trans>User ID</Trans>: {user.user_id}
                </p>
                <p className={classes['connection-text']}>
                    <Trans>Connection</Trans>: {user.connection_id}
                </p>
            </div>
        </motion.div>
    );
};
export default P2PWaitingUsersListItem;
